import { styled } from 'baseui'

export const OuterContainer = styled('div', {
  padding: '1rem',
  marginBottom: '2rem',
  color: 'white',
})

export const Block = styled('div', ({ $theme }) => ({
  padding: '1rem',
  marginTop: '2rem',
  marginBottom: '2rem',
  backgroundColor: 'white',
  borderRadius: '1rem',
  boxShadow: '0 2px 6px rgba(20,96,170,.3)',
  width: '100%',
  color: $theme.colors.contentSecondary,
}))

export const BlockTitle = styled('h2', ({ $theme }) => ({
  margin: '0.5rem 5px 5px 5px',
  color: $theme.colors.brandContentOnPrimary,
}))
